import {Guardian} from "./Guardian";
import {Sibling} from "../models/Sibling";
import {AdmissionType} from "./AdmissionType";
import {UploadFile} from "./uploadFile";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {ChildObject} from "../components/events/events.component";
import {FormControl, Validators} from "@angular/forms";

export interface FullChild {
  mothername: string;
  centres: any;
  id?: string;
  alloted?: boolean
  childCode: string;
  centreCode: string;
  omShanti?: boolean;                // for easy querying
  omShantiDetails?: OmShantiDetails; // optional object
  baseCentreCode: string;

  age:number;
  ageAsOnAdmission:number
  admissionData:AdmissionType[]
  medical_history:any[]
  baseCentreName: string;
  centreName: string;
  firstName: string;
  allergiesSelected: string[];
  diagnosisSelected: any[];
  middleName: string;
  heightin: string;
  lastName: string;
  bloodGroup: string;
  dob: Timestamp;
  gender: string;
  mobile: string;
  address: string;
  district: string;
  city: string;
  country: string;
  state: string;
  sponsored:false
  pincode: string;
  childAadhaar: string;
  hobbies: string;
  allergies: string;
  aspirations: string;
  // Basic Info
  selectCentre: string;
  stayedBefore: string;
  selectUnit: string;  //this is original
  currentUnit: string;  //this is wrong
  bag: string;
  guardianStayStatus: string;
  dateOfAdmission: Timestamp;

  //Basic Info End
  // Doc Section
  documents: string;
  drivingLicense: string;
  rationCard: string;
  electionId: string;
  // Doc Section End
//Guardian Info
  guardians: Guardian[],
  siblings: Sibling[],

  doctorName: string;
  fileNo: string;
  socialName: string;
  status:string
  isAlloted:boolean
  height: string;
  weight: string;
  prescribed: string;
  sickness: string;
  treatment: string;
  emergencyContactName:string;
  emrgencyContactNo:number
  medical: string;
  hospital: string;
  // allergies: new FormControl('', [Validators.required]),
  diagnosis: string;
  months: string;
  days: string;
  q1: string;
  q2: string;
  q3: string;
  q4: string;
  q5: string;
  q6: string;
  q7: string;
  q8: string;
  q9: string;
  events?: Events[];

  //Discharge Options
  dischargeDate?:Timestamp;
  dateOfDischarge?:Timestamp;
  followUpDate?:Date;
  reason?:string;
  remark?:string;
expired?:boolean;
  emergencyContactName1: string,
  emergencyContactRelation1: string,
  emergencyContactNumber1:string,
  emergencyContactName2: string,
  emergencyContactRelation2: string,
  emergencyContactNumber2: string,


admissionDocuments?:UploadFile[]
dischargeDocuments?:UploadFile[]
followUpAdmissionDocuments?:UploadFile[]
followUpDischargeDocuments?:UploadFile[]
lastDocId?: string;

}
export interface OmShantiDetails {
  dateOfOmShanti?: Timestamp;
  childName: string;
  childCode: string;
  modeOmShanti:string;
  remark?: string;
  photoUrls?: string | null;
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
}


export interface Events {
  description: string
  id: number
  res_timing: Date
  hash_tags:string
  res_type: string
  res_url: string
  title: string
  isBMI?:boolean;
  height?:string;
  child_codes:ChildObject[]
  event_name?:string;
  bmi?:string;
  weight?:string;



}

export interface ChildData {
  id?: string;
  alloted?: boolean
  childCode: string;
  centreCode: string;
  baseCentreCode: string;
  type?:string
  // currentCentreCode?:string;
  // currentCentreName?:string;
  age:number;
  ageAsOnAdmission:number
  admissionData:AdmissionType[]
  medical_history:any[]
  baseCentreName: string;
  centreName: string;
  admissionCycle?:number
  firstAdmission?:Timestamp
  firstDischarge?:Timestamp
  carryForward?: boolean  // Flag to identify carry-forward admissions
  firstName: string;
  allergiesSelected: string[];
  diagnosisSelected: any[];
  daysOfStay?: number | string | null;
  middleName: string;
  heightin: string;
  lastName: string;
  bloodGroup: string;
  dob: Timestamp;
  gender: string;
  mobile: string;
  address: string;
  district: string;
  city: string;
  country: string;
  state: string;
  sponsored:false
  pincode: string;
  childAadhaar: string;
  hobbies: string;
  allergies: string;
  aspirations: string;
  // Basic Info
  selectCentre: string;
  stayedBefore: string;
  selectUnit: string;  //this is original
  currentUnit: string;  //this is wrong
  bag: string;
  guardianStayStatus: string;
  dateOfAdmission: Timestamp;
  totalStayDays:any;
  //Basic Info End
  // Doc Section
  documents: string;
  drivingLicense: string;
  rationCard: string;
  electionId: string;
  // Doc Section End
//Guardian Info
  guardians: Guardian[],
  siblings: Sibling[],

  doctorName: string;
  fileNo: string;
  socialName: string;
  status:string
  isAlloted:boolean
  height: string;
  weight: string;
  prescribed: string;
  sickness: string;
  treatment: string;
  emergencyContactName:string;
  emrgencyContactNo:number
  medical: string;
  hospital: string;
  // allergies: new FormControl('', [Validators.required]),
  diagnosis: string;
  months: string;
  days: string;
  q1: string;
  q2: string;
  q3: string;
  q4: string;
  q5: string;
  q6: string;
  q7: string;
  q8: string;
  q9: string;
  events?: Events[];

  //Discharge Options
  dischargeDate?:Timestamp;
  dateOfDischarge?:Timestamp;
  followUpDate?:Timestamp;
  reason?:string;
  remark?:string;
  expired?:boolean;
  emergencyContactName1: string,
  emergencyContactRelation1: string,
  emergencyContactNumber1:string,
  emergencyContactName2: string,
  emergencyContactRelation2: string,
  emergencyContactNumber2: string,


  admissionDocuments?:UploadFile[]
  dischargeDocuments?:UploadFile[]
  followUpAdmissionDocuments?:UploadFile[]
  followUpDischargeDocuments?:UploadFile[]

}


// ─────────────────────────────────────────────────────────────────────────────
// AdmissionCycle: one document per stay (admission → discharge pair)
// Written to ALAdmissionCycles collection.
// If dateOfDischarge is null the child is *currently* admitted.
// ALChild/{childCode}.lastDocId always points to the latest cycle document.
// ─────────────────────────────────────────────────────────────────────────────
export interface AdmissionCycle {
  /* ── Core identity ── */
  cycleId: string;               // Firestore document ID (self-referencing)
  admissionCount?: number;       // optional global sequence number if needed
  childCode: string;
  childName: string;
  firstName: string;
  lastName: string;
  createdAt: Date;
  createdBy: string;
  updatedAt?: Date;

  /* ── Classification ── */
  cycleNumber: number;           // 1-based; 1 = first stay, 2 = first follow-up, …
  isFollowUp: boolean;           // false for cycleNumber === 1
  isUnique: boolean;             // mirrors AdmissionLog.isUnique (true for cycle 1)
  isCurrentlyAdmitted: boolean;  // true when dateOfDischarge is null
  followUpOfAdmissionId?: string;

  /* ── Location ── */
  centreCode: string;
  centreName: string;
  currentUnit: string;

  /* ── Dates ── */
  dateOfAdmission: Date;
  dateOfDischarge: Date | null;  // null = not yet discharged

  /* ── First-ever admission / discharge for this child (across all cycles) ── */
  firstAdmission: Date;          // dateOfAdmission from cycle 1 (cycleNumber === 1)
  firstDischarge: Date | null;   // dateOfDischarge from cycle 1; null if never discharged

  /* ── Child demographics ── */
  dob: Date;
  gender: string;
  age: number;
  hospital: string;
  bloodGroup: string;
  diagnosis: any[];
  city: string;
  state: string;

  /* ── Transfer history (optional) ── */
  transferred?: boolean;
  transferDate?: Date;
  transferFromCentreCode?: string;
  transferFromCentreName?: string;
  transferFromUnit?: string;
  transferToCentreCode?: string;
  transferToCentreName?: string;
  transferToUnit?: string;
  transferReason?: string;
  transferBy?: string;
  transferOfAdmissionId?: string;
  transfers?: TransferRecord[];

  /* ── Guardian info ── */
  guardian1Name: string;
  guardian2Name: string;
  guardian1Occupation: string;
  guardian2Occupation: string;
  guardian1Relation: string;
  guardian2Relation: string;
}

export interface TransferRecord {
  fromCentreCode?: string;
  fromCentreName?: string;
  fromUnit?: string;
  toCentreCode?: string;
  toCentreName?: string;
  toUnit?: string;
  date: Date;
  reason?: string;
  by?: string;                   // user id or name who initiated transfer
  relatedAdmissionId?: string;   // link to admission being transferred (if applicable)
}
export interface AdmissionLog {
  /* ── Core identity ── */
  admissionId?: string;          // populated when saved to Firestore
  admissionCount?: number;       // sequential global counter (set by service)
  childCode: string;
  childName?: string;            // firstName + lastName (set by service)
  firstName?: string;
  lastName?: string;
  createdAt?: Date;
  createdBy?: string;            // 'System' | user uid/name

  /* ── Classification ── */
  isUnique: boolean;             // true for cycle 1 admission & discharge
  type: 'Admission' | 'Discharge' | 'FollowUpAdmission' | 'FollowUpDischarge' | 'Transfer';
  followUpOfAdmissionId?: string;

  /* ── Location ── */
  centreCode: string;            // current centre after transfer
  centreName: string;
  currentUnit: string;           // current unit after transfer

  /* ── Dates ── */
  dateOfAdmission?: Date;
  dateOfDischarge?: Date;

  /* ── Child demographics ── */
  dob: Date;
  gender: string;
  age: number;
  bloodGroup: string;
  hospital: string;
  city: string;
  state: string;
  diagnosis: string[];

  /* ── Transfer history (optional) ── */
  transferred?: boolean;
  transferDate?: Date;
  transferFromCentreCode?: string;
  transferFromCentreName?: string;
  transferFromUnit?: string;
  transferToCentreCode?: string;
  transferToCentreName?: string;
  transferToUnit?: string;
  transferReason?: string;
  transferBy?: string;
  transferOfAdmissionId?: string;
  transfers?: TransferRecord[];

  /* ── Guardian info ── */
  guardian1Name?: string;
  guardian2Name?: string;
  guardian1Occupation?: string;
  guardian2Occupation?: string;
  guardian1Relation?: string;
  guardian2Relation?: string;
}
// export interface AdmissionLog {
//   centreName: string;
//   childCode: string;
//   currentUnit: string;
//   dob: Date;
//   gender?: string;
//   hospital?: string;
//   isUnique: boolean;
//   centreCode?: string;
//   bloodGroup?: string;
//   diagnosis?: string;
//   state?: string;
//   createdAt: Date;
//   dateOfAdmission?: Date;
//   dateOfDischarge?: Date;
// }
